import React, { useEffect, useState } from "react";
import { GoCheckCircleFill } from "react-icons/go";
import logo from '../assets/AUSM-LOGO.png';

const SuccessPage = ({ redirectURL, formData }) => {
  const [timer, setTimer] = useState(10);

  useEffect(() => {
    let interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          if (redirectURL) {
            window.location = `${redirectURL}`;
          } else {
            window.location.reload(true);
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [redirectURL]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6 font-sans">
      <div className="max-w-3xl w-full bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
        <div className="h-2 bg-[#b60041]"></div>
        
        <div className="p-12 text-center">
            {/* Logo */}
            <div className="flex justify-center mb-8">
                <div className="bg-[#b60041] p-3 rounded-2xl shadow-lg">
                    <img src={logo} alt="AUMS" className="h-12 w-auto" />
                </div>
            </div>

          <div className="mb-6 flex justify-center">
            <div className="bg-green-50 p-6 rounded-full">
              <GoCheckCircleFill className="text-8xl text-green-500 animate-bounce-short" />
            </div>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Application Submitted Successfully!
          </h1>
          
          <div className="w-20 h-1 bg-green-500 mx-auto mb-8 rounded-full"></div>
          
          <div className="space-y-4 text-gray-600 text-lg mb-10 text-justify px-4">
            <p>
              Your initial application has been received. Selected applicants will be contacted 
              to proceed with the formal application process and fee payments.
            </p>
            <p className="text-sm border-l-4 border-amber-400 bg-amber-50 p-4 rounded-r-lg">
              <span className="font-bold text-amber-900 block mb-1">Important Note:</span>
              No application is considered formal without payment of application and admission test fees. 
              Payment does not guarantee admission.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 mb-8 border border-gray-200">
             <p className="text-right rtl text-lg font-bold text-blue-900" dir="rtl">
                أقر أنا <span className="underline decoration-red-500 underline-offset-4 mx-2">{formData?.arabicFirstName?.value || ""} {formData?.arabicLastName?.value || ""}</span> 
                صاحب البطاقة المدنية رقم <span className="underline decoration-red-500 underline-offset-4 mx-2 tracking-widest">{formData?.civilId?.value || ""}</span> 
                بأنني أوافق على جميع الشروط والأحكام المذكورة أعلاه.
            </p>
          </div>

          <div className="flex items-center justify-center gap-4 text-gray-400">
            <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-sm font-medium">
              Redirecting to home in <span className="text-green-600 font-bold text-lg tabular-nums">{timer}</span> seconds...
            </p>
          </div>
        </div>
        
        <div className="bg-gray-900 py-4 px-12 text-center">
            <p className="text-gray-400 text-xs uppercase tracking-widest font-semibold">
                AUMS • Academic Excellence
            </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;


